<div class="banner">
  <div class="banner-img">
    <img src="./assets/images/exclamation_banner.svg" alt="">
  </div>
  <div>
    <div class="banner-firstTxt">{{copyTxt1}}</div>
    <div class="banner-secondTxt" [ngStyle]="language == 'fr_FR' ? {'font-size': '15px'} : {'font-size': '18px'}">{{copyTxt2}}</div>
  </div>
</div>
